import "./StaleChip.css";

export interface StaleChipProps {
  readonly active: boolean;
}

/**
 * CR-111: Amber "Stale" warning chip. Rendered conditionally — when
 * `active` is false the component returns null so call sites can keep
 * layout simple (`<StaleChip active={theme.is_stale} />`). Shared by
 * the themes grid card (ThemeCard) and the detail header strip
 * (ThemeMetadataStrip) per the plan's Task-9 REFACTOR directive.
 */
export function StaleChip({ active }: StaleChipProps): JSX.Element | null {
  if (!active) return null;
  return <span className="stale-chip">Stale</span>;
}
